import { Location } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { DppEnrollmentFacade } from './features/dpp-enrollment/store/facade/dpp-enrollment.facade';

@Component({
    selector: 'fc-app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class AppComponent implements OnInit {
    private readonly destroy$ = new Subject<void>();

    title$ = this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.router.routerState.snapshot.root.firstChild?.data['title']),
        takeUntil(this.destroy$),
    );

    constructor(
        private readonly router: Router,
        private readonly location: Location,
        private readonly dppEnrollmentFacade: DppEnrollmentFacade,
    ) {}

    ngOnInit(): void {
        const queryParams = new URLSearchParams(location.search);
        const digitalPayeeId = Number(queryParams.get('digitalPayeeId'));
        if (queryParams.get('source') === 'stripe' && digitalPayeeId) {
            this.dppEnrollmentFacade.returnedFromStripe(digitalPayeeId);
            this.removeStripeQueryParams();
        }
    }

    private removeStripeQueryParams(): void {
        const searchParams = new URLSearchParams(location.search);

        searchParams.delete('source');
        searchParams.delete('digitalPayeeId');

        const currentPath = this.location.path(false);

        const searchString = searchParams.toString();
        const queryString = searchString ? `?${searchString}` : '';

        const newUrl = currentPath + queryString + location.hash;

        this.location.replaceState(newUrl);
    }
}
